export const INPUT_TYPES = {
  TEXT: 'text',
  TEXT_AREA: 'textArea',
  PASSWORD: 'password',
  SELECT: 'select'
};


export const WEBCAST_GUEST = 'Guest';
export const WEBCAST_CHRISTADELPHIAN = 'Affiliate_Ecclesia_Member';
export const WEBCAST_MEMBER = 'Book_Road_Member';

export const EMAIL_TYPE = 'EMAIL';
export const USERNAME_TYPE = 'USERNAME';

export const MODES = {
  Create:'create',
  Assign: 'assign',
  View: 'view',
  Edit: 'edit',
  Delete: 'delete',
  Reject: 'reject'
};
